/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState } from "react";
// import { AutoComplete, Input } from "antd";
// import { MdFlightTakeoff } from "react-icons/md";
import "./CustomAutoComplete.scss";
import { searchAirports } from "services/flights";
import Autosuggest from "react-autosuggest";
import { errorToast, getErrorObject, verifyObject } from "utilities/utils";
// import Spinner from "components/common/Spinner";

// const renderItem = (title, shortName) => ({
//   value: title,
//   label: (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "space-between",
//       }}
//     >
//       <span>
//         <MdFlightTakeoff style={{ fontSize: 30 }} />
//         <span> {title.split("/")[0]}</span>
//       </span>

//       <span>{shortName}</span>
//     </div>
//   ),
// });

export const CustomAutoComplete = ({
  type,
  getFromToValue,
  index,
  popupClassName,
  isFromElse,
  clearValues,
}) => {
  //states
  const [airports, setAirportsData] = useState([]);
  const [value, setValue] = useState("");
  // const [isLoading, setLoading] = useState(false);


  const handleSearch = ({ value }) => {
    console.log(value);

    setValue(value);
    handleAirportSearchSearch(value);
    // setOpen(true);
  };

  useEffect(() => {
    console.log("isClearValues",clearValues)
    if (clearValues) {
      setValue("");
    }
  }, [clearValues]);

  //flights or airports search
  const handleAirportSearchSearch = async (search, type) => {
    try {
      // await setLoading(true);
      let airportResponse = await searchAirports({ filter: search });
      let dataArray = verifyObject(airportResponse, "data.data.docs", []);
      let airportsArray = [];
      dataArray.map((d) => {
        airportsArray = [
          ...airportsArray,
          {
            id: d.iata,
            name: `${d.name}/${d.iata}`,
            city: d.city,
            country: d.country,
          },
        ];
        return null;
      });
      setAirportsData(airportsArray);
      // await setLoading(false);
    } catch (e) {
      const { message } = getErrorObject(e);
      errorToast({
        content: message,
      });
      // await setLoading(false);
    }
  };

  // const debouncedAirportSearch = useCallback(
  //   debounce(handleAirportSearchSearch, 1000),
  //   []
  // );
  function renderSuggestion(suggestion, { query }) {
    // const matches = AutosuggestHighlightMath(suggestion.name, query);
    // const parts = AutosuggestHighlightParse(suggestion.name, matches);

    return (
      <div class="makeFlex hrtlCenter">
        <img
          class="icLocAlt appendRight8"
          src="https://imgak.mmtcdn.com/flights/assets/media/dt/common/icons/ic-flight-onward.png"
          alt="icon"
        />
        <div class="calc60">
          <p class="font-size-14 appendBottom5 blackText">{suggestion.city}</p>
          <p class="font-size-12 greyText appendBottom3">
            {suggestion.name.split("/")[0]}
          </p>
        </div>
        <div class="pushRight font14 lightGreyText latoBold">
          {" "}
          {suggestion.name.split("/")[1]}
        </div>
      </div>
    );
  }

  const getSuggestionValue = (suggestion) => {
    // let { name } = suggestion;
    console.log("suggestion", suggestion);
    let name = `${suggestion?.city}/${suggestion?.name?.split("/")[1]}, ${
      suggestion?.name?.split("/")[0]
    }`;
    if (isFromElse) {
      name = `${suggestion?.city}, ${suggestion?.name?.split("/")[0]}`;
    }
    if (index !== undefined) {
      getFromToValue(name, type, index);
    } else {
      getFromToValue(name, type);
    }
    return name;
  };
  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };

  console.log("---->index", index);
  console.log("airports", airports);
  const inputProps = {
    placeholder: type,
    value,
    onChange: onChange,
    className: isFromElse && "form-control form-control-sm",
  };

  return (
    <Autosuggest
      suggestions={airports}
      onSuggestionsFetchRequested={handleSearch}
      getSuggestionValue={getSuggestionValue}
      inputProps={inputProps}
      renderSuggestion={renderSuggestion}
      highlightFirstSuggestion={true}
    
    />
  );
};
